import React, { useState } from "react";
import { FiUploadCloud } from "react-icons/fi";
import "./CreateMatadata.css";
import { useDispatch, useSelector } from "react-redux";
import { MetaDataCreate } from "../../actions/MetaDataAction";
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import { toast } from "react-toastify";
const CreateMetaData = () => {
  const { loading } = useSelector((state) => state.metaDataState);

    const navigator=useNavigate()
  const dispatch = useDispatch();
  const [defaultImage, setDefaulImage] = useState("");
  const [image, setImage] = useState(null);
  const [metadata, setMetadata] = useState({
    pagename: "",
    title: "",
    description: "",
    keywords: "",
  });

  const handleImage = (e) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        setDefaulImage(reader.result);
        setImage(e.target.files[0]);
      }
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    setMetadata({ ...metadata, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("image", image);
    formData.append("pagename", metadata.pagename);
    formData.append("title", metadata.title);
    formData.append("description", metadata.description);
    formData.append("keywords", metadata.keywords);
  try {
    await dispatch(MetaDataCreate(formData));
    toast.success("created successfully");
    navigator("/allpage-meta-data",{ refresh: true })
  } catch (error) {
    toast.error(error?.response?.data?.message || "Unable to create metadata");
  }
  };
  return (
    <form
      style={{ marginTop: "40px" }}
      className="CreateMetaData"
      onSubmit={handleSubmit}
    >
      <label htmlFor="image" className="custom-file-input">
        {
          <img
            style={{ position: "relative", zIndex: "5" }}
            src={image ? defaultImage : ""}
            alt=""
          />
        }
        <FiUploadCloud className="upload_icon" />
      </label>
      <input
        type="file"
        onChange={handleImage}
        name="image"
        id="image"
        style={{ display: "none" }}
      />
      <input
        type="text"
        placeholder="Page Path"
        value={metadata.pagename}
        onChange={handleChange}
        name="pagename"
      />
      <input
        type="text"
        placeholder="Meta Title"
        value={metadata.title}
        onChange={handleChange}
        name="title"
      />
      <input
        type="text"
        placeholder="Meta Description"
        value={metadata.description}
        onChange={handleChange}
        name="description"
      />
      <input
        type="text"
        placeholder="Meta keyword"
        value={metadata.keywords}
        onChange={handleChange}
        name="keywords"
      />
     <button type="submit" className="CreateMetaData_btn">
        {loading ? (
          <RotatingLines
            visible={true}
            height="20"
            width="20"
            color="grey"
            strokeColor="black"
            strokeWidth="5"
            animationDuration="0.75"
            ariaLabel="rotating-lines-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        ) : (
          "Create"
        )}
      </button>
    </form>
  );
};

export default CreateMetaData;
